export default __webpack_public_path__ + "static/media/assets_liabilities_01.ab866cbe.png";